module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "h3 mt0"
  }, [_vm._v("Become a Reviewer")]), _vm._v(" "), (_vm.applied) ? _c('p', {
    staticClass: "p"
  }, [_vm._v("Your current application to become a Reviewer is still pending, we will contact you via email with the results")]) : _vm._e(), _vm._v(" "), (!_vm.dataComplete) ? _c('p', {
    staticClass: "p"
  }, [_vm._v("You must complete all sections in "), _c('router-link', {
    staticClass: "fw-bold c-secondary",
    attrs: {
      "to": {
        name: 'dashboard-profile-info'
      }
    }
  }, [_vm._v("My Information")]), _vm._v(" and add at least one location to "), _c('router-link', {
    staticClass: "fw-bold c-secondary",
    attrs: {
      "to": {
        name: 'dashboard-dentist-locations'
      }
    }
  }, [_vm._v("My Locations")]), _vm._v(" before you can apply to become a Reviewer")], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.applied && _vm.dataComplete),
      expression: "!applied && dataComplete"
    }]
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("Join the movement! Do you want to help highlight good dental care and identify bad work?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("We’re looking for good dentists and specialist to join our pool of expert reviewers. The reviewing process is fast, simple and anonymous. You can log on to our secure site when you have time and quickly review a set of radiographs right on your mobile phone.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Join the fight for transparency in the dental industry!")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Please make sure that all information listed in your dentist profile is accurate. To verify your identity, please upload the following information:")]), _vm._v(" "), _c('module-form', {
    staticClass: "reviewer-form",
    attrs: {
      "button": "primary",
      "form-id": "reviewer-form",
      "fields": _vm.fields,
      "submit": "Register as Reviewer",
      "action": _vm.action,
      "success": _vm.success,
      "fail": _vm.fail
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "p"
  }, [_vm._v("The criteria for reviewing root canals isn’t our opinion, "), _c('a', {
    attrs: {
      "href": "https://www.aae.org/specialty/wp-content/uploads/sites/2/2018/04/TreatmentStandards_Whitepaper.pdf",
      "target": "_blank"
    }
  }, [_vm._v("it’s the official position of the AAE and ADA.")]), _vm._v(" We want to provide patients and dentists with clear criteria on quality dental care.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d4b636a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/dashboard/ReviewerApplication.vue
// module id = 350
// module chunks = 0